import { apiGet } from '../../../generic/Api_Functions'
import {
  collectFeatureGroupBaselines,
  FEATURE_GROUP_CONTROLLED_REVISIONS_SETTING,
  isFeatureGroupRevisionControlled,
  prepareFeatureGroupsForSave
} from './featureGroupRevisionControl'

/**
 * Story 186 (S114): the save payload of the fabrication order editors, which save on their own instead of through
 * Workflow.jsx. Reads the revision mode when saving (error or missing setting means FREE, RN1) and applies the same pure
 * preparation as the editor of the templates, taking the persisted copy of the feature groups from the workflow as it was
 * loaded (the `original` those screens already keep to compute the diff).
 *
 * @param {object} workflow Workflow as edited
 * @param {object} original Workflow as loaded
 * @returns {Promise<object>} The workflow to send (the same reference in FREE mode)
 */
export const prepareFabricationOrderWorkflowForSave = async (workflow, original) => {
  let controlled = false
  try {
    controlled = isFeatureGroupRevisionControlled(await apiGet('settings/' + FEATURE_GROUP_CONTROLLED_REVISIONS_SETTING))
  } catch (error) {
    controlled = false
  }
  return prepareFeatureGroupsForSave(workflow, collectFeatureGroupBaselines(original), { controlled })
}
